import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { DashboardOverview, DashboardTrends } from '../types';

export const useDashboardOverview = () => {
    return useQuery({
        queryKey: ['dashboard', 'overview'],
        queryFn: async () => {
            const { data } = await api.get<{ success: boolean; data: DashboardOverview }>('/dashboard/overview');
            return data.data;
        },
    });
};


export const useDashboardTrends = (days: number = 30, granularity: 'daily' | 'weekly' | 'monthly' = 'daily') => {
    return useQuery({
        queryKey: ['dashboard', 'trends', days, granularity],
        queryFn: async () => {
            const { data } = await api.get<{ success: boolean; data: DashboardTrends }>(`/dashboard/trends?days=${days}&granularity=${granularity}`);
            return data.data;
        },
    });
};

